import React from "react"
import { RenderElementProps } from "slate-react"

const HeadingExtraSmall = ({ children, attributes }: RenderElementProps) => {
    return (
        <div {...attributes} className="font-gibson mb-4 text-lg last:mb-0 sm:mb-5 sm:text-xl lg:text-2xl">
            {children}
        </div>
    )
}

export default HeadingExtraSmall
